import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PopularCourseTopUniversitiesService} from '../../../shared/services/popular-course-top-universities.service';
import {environment} from '../../../../environments/environment';

import {UtilsService} from '../../../shared/services/utils.service';
@Component({
    selector: 'app-popular-course-top-universities',
    templateUrl: './popular-course-top-universities.component.html',
    styleUrls: ['./popular-course-top-universities.component.scss']
})
export class PopularCourseTopUniversitiesComponent implements OnInit {
    public popularCourseId: any;
    submitting: any = false;
    dataExists: any = false;

    editorBlocks: Array<{type: 'content' | 'table', value: string}> = [{type: 'content', value: ''}];
    tinymceApiKey = environment.tinymceApiKey;

    tableEditorInit = {
        menubar: false,
        branding: false,
        plugins: 'lists link autolink charmap media searchreplace visualblocks wordcount codesample table',
        toolbar: 'undo redo | bold italic underline | bullist numlist | link media charmap | ' +
            'table tableinsertrowbefore tableinsertrowafter tabledeleterow tableinsertcolbefore tableinsertcolafter tabledeletecol | removeformat'
    };

    constructor(private activatedRoute: ActivatedRoute,
                private popularCourseTopUniversitiesService: PopularCourseTopUniversitiesService) {
    }

    ngOnInit(): void {
        this.popularCourseId = this.activatedRoute.snapshot.parent.params['id'];
        this.refresh();
    }

    refresh() {
        this.popularCourseTopUniversitiesService.detailByAdmin(this.popularCourseId).subscribe(data => {
            this.dataExists = !!(data && data['info']);

            const blocks = (data && data['info']) ? UtilsService.splitEditorBlocks(data['info']) : [];
            if (data && data['table_html']) {
                blocks.push({type: 'table', value: data['table_html']});
            }
            this.editorBlocks = blocks.length ? blocks : [{type: 'content', value: ''}];
        });
    }
    addEditorBlock(editor: 'content' | 'table') {
        this.editorBlocks.push({type: editor, value: ''});
    }

    removeEditorBlock(index: number) {
        this.editorBlocks.splice(index, 1);
    }


    submit() {
        const info = UtilsService.joinEditorBlocks(this.editorBlocks);

        const params = {
            'info': info ? UtilsService.encodeHtml(info) : '',
            'table_html': ''
        };
        this.submitting = true;
        if (this.dataExists) {
            this.popularCourseTopUniversitiesService.updateByAdmin(this.popularCourseId, params).subscribe(data => {
                this.submitting = false;
            }, error => {
                this.submitting = false;
            });
        } else {
            this.popularCourseTopUniversitiesService.createByAdmin(this.popularCourseId, params).subscribe(data => {
                this.submitting = false;
                this.dataExists = true;
            }, error => {
                this.submitting = false;
            });
        }
    }
}
